import { Component, HostListener, Input, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ReportNote, ReportPage } from 'src/app/model';
import { ReportProvider } from 'src/app/providers';
import { ToasterService } from 'src/app/services';

@Component({
  selector: 'app-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.scss']
})
export class NotesComponent {

  @Input() reportVersionId: string = '';
  @Input() pageId: number = null;
  @Input() notesButtonClass: string = 'large__button';

  @ViewChild('notes') notes;
  notesDialogVisible: boolean = false;
  notePageName: string = '';

  public allNotes: boolean = false;
  public editIndex: number;
  public editMode: boolean = false;
  oldNoteText: string = '';

  notesList: Array<ReportNote> = [];
  allNotesList: Array<ReportNote> = [];

  noteCount: number = null;
  allNoteCount: number = null;

  newNote: ReportNote;
  updateNote: ReportNote;

  constructor(private router: ActivatedRoute, private reportProvider: ReportProvider, private toastr: ToasterService) {
    this.router.url.subscribe((route) => {
      if (route.length) {
        this.notePageName = route[0].path.replace("-", " ");
      } else {
        this.notePageName = route[route.length - 1].path.replace("-", " ");
      }
    });
    this.newNote = new ReportNote();
  }

  toggleNotesDialog() {
    this.notesDialogVisible = !this.notesDialogVisible;

    if (this.notesDialogVisible) {
      this.getAllNotes();
    }
  }

  @HostListener('document:click', ['$event.target'])
  clickedOutside(targetElement) {
    if (this.notes) {
      const clickedInside = this.notes.nativeElement.contains(targetElement);
      if (!clickedInside) {
        this.notesDialogVisible = false;
        this.clearEdit(null);
        this.clearNewNote();
      }
    }
  }

  toggleAllNotes(event) {
    event.stopPropagation();
    this.allNotes = !this.allNotes;
  }

  autoGrow(event) {
    event.target.style.height = 'auto';
    event.target.style.height = event.target.scrollHeight + "px";
    if (event.target.value == '') {
      event.target.style.height = '24px';
    }
  }

  editNote(index, note: ReportNote) {
    this.editIndex = index;
    this.editMode = true;
    this.oldNoteText = note.TEXT;
    this.updateNote = note;
  }

  updateNoteSave(event) {
    event.stopPropagation();
    this.reportProvider.saveReportNote(this.reportVersionId, this.updateNote).subscribe(resp => {
      if (resp.success) {
        this.toastr.success('Note updated successfully!');
        this.updateNote = new ReportNote();
        this.clearEdit(event);
      }
    }, err => {
      // Error Handling
    });
  }

  clearEdit(event, note?: ReportNote) {
    if (event)
      event.stopPropagation();

    this.editIndex = null;
    this.editMode = false;

    if (note)
      note.TEXT = this.oldNoteText;
  }

  deleteNote(event, noteId, index) {
    event.stopPropagation();
    this.reportProvider.deleteReportNote(this.reportVersionId, noteId).subscribe(res => {
      if (res.success) {
        this.toastr.success('Note deleted successfully!');
        this.notesList.splice(index, 1);
        this.allNotesList.splice(this.allNotesList.findIndex(el=> el.ID == noteId), 1);
        this.setNotesCounts();
      }
    }, err => {
      // Error Handling
    });
  }

  clearNewNote() {
    this.newNote.TEXT = '';
  }

  setNotesCounts() {
    this.noteCount = this.notesList.length;
    this.allNoteCount = this.allNotesList.length;
  }

  getAllNotes() {
    this.reportProvider.getReportNote(this.reportVersionId).subscribe(res => {
      if (res.success) {
        this.allNotesList = res.result;
        this.notesList = this.allNotesList.filter(el => el?.PAGE?.ID == this.pageId);

        this.allNotesList.sort((a, b) => Number(a.PAGE.ID) - Number(b.PAGE.ID));

        this.setNotesCounts();
      }
    }, err => {
      // Error Handling
    });
  }

  postNewOrEditNote() {
    if (this.newNote?.TEXT) {

      if (!this.newNote.PAGE) {
        const page = new ReportPage();
        page.ID = this.pageId;
        this.newNote.PAGE = page;
      }

      this.reportProvider.saveReportNote(this.reportVersionId, this.newNote).subscribe(resp => {
        if (resp.success) {
          this.allNotesList.push(resp.result);
          this.notesList.push(resp.result);
          this.setNotesCounts();
          this.toastr.success('Note added successfully!');
          this.newNote = new ReportNote();
        }
      }, err => {
        // Error Handling
      });
    }
  }

  @HostListener('window:keyup.escape', ['$event'])
  onKeyUp($event: KeyboardEvent) {
    if (this.notes) {
      this.notesDialogVisible = false;
      this.clearEdit(null);
      this.clearNewNote();
    }
  }

}
